import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';
import { RegisterOwner, RegisterOwnerAddresses } from '../../../domain/model/owner/registerOwner';
import { MatStepper } from '@angular/material/stepper';
import { passwordMatchValidator } from '../../../shared/utils/mustMatchValidators';
import { OwnerEnrollment } from '../../../domain/model/enrollment/ownerEnrollment';
import { PropertyEnrollment } from '../../../domain/model/enrollment/propertyEnrollment';
import { HotelMotelEnrollment } from '../../../domain/model/enrollment/hotelMotelEnrollment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { CommonServices } from '../../../domain/service/commonService';
import { EnrollmentService } from '../../../domain/service/enrollmentService';
import { BrandingService } from '../../../domain/service/brandingService';

@Component({
  selector: 'app-register-owner',
  templateUrl: './register-owner.component.html',
  styleUrl: './register-owner.component.css'
})
export class RegisterOwnerComponent implements OnInit{
  @ViewChild('stepper')
  private myStepper!: MatStepper;
  selectedIndex: 0 = 0;
  completed: boolean = true;
  state: string = 'done';
  registerAs:string = '0';
  isOwner : boolean = true;
  registerAsAddress:string = '1';
  stepCompleted: boolean = false;
  private fb = inject(FormBuilder);
   model: RegisterOwner = {
    printedName: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    isUsingTaxRepresentative: false,
    taxRepresentativeFirstName: '',
    taxRepresentativeLastName: '',
    receiptByEmail: false,
    receiptByText: false,
    memo: '',
    note: '',
    accountType: 0,
    accountIs: 0,
    accountNumber: '',
    status: 0,
    createdAt: new Date(),
    addressList: []
  };
  states: DropDownModel[] = [];
  country: DropDownModel[] = [];
  showTaxRepresentativeForm : boolean = false;
  default =  new FormGroup({
 
  });
  firstStep =  new FormGroup({
    printedName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ])
  });
  
  selectUserType = new FormGroup({
    userType: new FormControl('', [
      Validators.required,
     
    ])
  });
  
  secondStepForm = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.maxLength(320),
      Validators.email
    ]),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
    ]),
   
   })

  managementCompany = new FormGroup({
    businessLegalName: new FormControl('', [
      Validators.required,
     
    ]),
    businessDBAname: new FormControl('', [
     
    ]),
    primaryContactFirstName: new FormControl('', [
      Validators.required,
    ]),
    primaryContactLastName: new FormControl('', [
      Validators.required,
    ]),
    primaryContactEmail: new FormControl('', [
      Validators.required,
      Validators.email
    ]),
    primaryContactPhoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
    ]),
  });
  hotelMotel =  new FormGroup({
    personNameOrCompanyName: new FormControl('', [
      Validators.required,
     
    ]),
    email: new FormControl('', [
      Validators.required,
     Validators.email
    ]),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
    ]),
    primaryContactFirstName: new FormControl('', [
      Validators.required,
    ]),
    primaryContactLastName: new FormControl('', [
      Validators.required,
    ]),
  });
  addressOwner =  new FormGroup({
    address1:new FormControl('',[Validators.required]),
    address2:new FormControl('',[Validators.required]),
    city:new FormControl('',[Validators.required]),
    state:new FormControl('',[Validators.required]),
    zipCode:new FormControl('', [
      Validators.required,
      Validators.maxLength(400),
      Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
    ]),
    note:new FormControl(''),
  });

  addressProperty =  new FormGroup({
    address1:new FormControl('',[Validators.required]),
    address2:new FormControl('',[Validators.required]),
    city:new FormControl('',[Validators.required]),
    state:new FormControl('',[Validators.required]),
    zipCode:new FormControl('', [
      Validators.required,
      Validators.maxLength(400),
      Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
    ]),
    websiteUrl:new FormControl(''),
    note:new FormControl(''),
  });



  addressOwnerInternational =  new FormGroup({
    internationalAddressName:new FormControl('',[Validators.required]),
    internationalPoBox:new FormControl('',[Validators.required]),
    internationalCityProvinceState:new FormControl('',[Validators.required]),
    internationalCountry:new FormControl('',[Validators.required]),
    note:new FormControl(''),
  });

  


  
 

  customForm = this.secondStepForm;
  readonly branding$ = inject(BrandingService).get();

  constructor(public dialogRef: MatDialog,private commonServices: CommonServices ,private _formBuilder: FormBuilder,private router: Router,private http: HttpClient, private enrollment : EnrollmentService) {}

  ngOnInit(): void {
    
    this.commonServices.getAllCountry()
    .subscribe(data => {
      this.country = data;
    });

    this.commonServices.getAllState(233)
    .subscribe(data => {
      this.states = data;
    });
 
  }
 
 
  onSelectTap($event: { index: string | number; }){
    
}
 

radioChange(event: any) {
  this.registerAs = event.value;
  this.managementCompany.reset();
  this.managementCompany.clearValidators();
  this.secondStepForm.reset();
  this.hotelMotel.reset();
  if (event.value == '1'){
    this.isOwner = true;
    this.registerAsAddress = '1'
    
  }else {
    this.registerAsAddress = '3'
  }

  
}
radioChangeAddress(event: any) {
  this.registerAsAddress = event.value;
 
  
}
 
getFormGroup() {
  if (this.registerAs == '1'){
  
    return this.secondStepForm;
  }
  if(this.registerAs == '2'){
    return this.managementCompany;
  }
  if(this.registerAs == '3'){
    return this.hotelMotel;
  }
  return this.default;
} 

getFormGroupAddress() {
  if (this.registerAsAddress == '1'){
    return this.addressOwner
  }
  if (this.registerAsAddress == '2'){
    return this.addressOwnerInternational
  }
  if (this.registerAsAddress == '3'){
    return this.addressProperty
  }
  return this.default;
} 
openDialog(): void {
  const dialogRef = this.dialogRef.open(DialogConfirmComponent, {
    width: '479px',
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog was closed');
  });
}
  save(){
 this.stepCompleted = true;
 let printedName = this.firstStep.get('printedName')?.value;
 this.firstStep.reset();
 this.secondStepForm.reset();
 this.addressProperty.reset();
 this.addressOwner.reset();
 this.addressOwnerInternational.reset();
 this.managementCompany.reset();
 this.addressProperty.reset();
 this.selectUserType.reset();
 if (this.registerAs == '1'){
// let modelOwner : OwnerEnrollment = {
//   printedName: printedName ?? '',
//   firstName: this.secondStepForm.get('firstName')?.value ?? '',
//   lastName: this.secondStepForm.get('lastName')?.value ?? '',
//   email: this.secondStepForm.get('email')?.value ?? '',
//   phoneNumber: this.secondStepForm.get('phoneNumber')?.value ?? '',
//   streetAddress: this.addressOwner.get('address1')?.value ?? '',
//   aptUnitSuite: this.addressOwner.get('address2')?.value ?? '',
//   city: this.addressOwner.get('city')?.value ?? '',
//   zipCode: this.addressOwner.get('zipCode')?.value ?? '',
//   internationalAddressName: '',
//   internationalPoboxNumber: '',
//   internationalCityStateProvince: '',
//   note: '',
//   stateId: Number.parseInt(this.addressOwner.get('state')?.value ?? ''),
//   countryId: 0,
//   id: 0,
//   owners: []
// };
//this.enrollment.registerOwner(modelOwner);
 } 
 if (this.registerAs =='2'){
  // let modelProperty : PropertyEnrollment = {
  //   id: 0,
  //   printedName: printedName??'',
  //   businessLegalName: this.managementCompany.get('businessLegalName')?.value??'',
  //   businessDbaName: this.managementCompany.get('businessDBAname')?.value??'',
  //   primaryContactFirstName: this.managementCompany.get('primaryContactFirstName')?.value??'',
  //   primaryContactLastName: this.managementCompany.get('primaryContactLastName')?.value??'',
  //   primaryContactEmail: this.managementCompany.get('primaryContactEmail')?.value??'',
  //   primartContactPhoneNumber: this.managementCompany.get('primaryContactPhoneNumber')?.value??'',
  //   streetAddress: this.addressProperty.get('address1')?.value??'',
  //   aptUnitSuite:this.addressProperty.get('address2')?.value??'',
  //   city: this.addressProperty.get('city')?.value??'',
  //   stateId: Number.parseInt(this.addressProperty.get('state')?.value??'') ,
  //   zipCode: this.addressProperty.get('zipCode')?.value??'',
  //   webSiteUrl: this.addressProperty.get('websiteUrl')?.value??'',
  //   internationalAddressName:this.addressOwnerInternational.get('internationalAddressName')?.value??'',
  //   streetAddressPoBoxNumber: this.addressOwnerInternational.get('internationalPoBox')?.value??'',
  //   internationalCityStateProvince: this.addressOwnerInternational.get('internationalCityProvinceState')?.value??'',
  //   note: '',
  //   countryId:  Number.parseInt(this.addressOwnerInternational.get('internationalCountry')?.value??'') ,
  // };
  //this.enrollment.registerProperty(modelProperty);
 }
 if (this.registerAs =='3'){
  // let hotelMotelEnrollment : HotelMotelEnrollment = {
  //   id: 0,
  //   printedName: printedName??'',
  //   personName: this.hotelMotel.get('personNameOrCompanyName')?.value??'',
  //   companyName: this.hotelMotel.get('personNameOrCompanyName')?.value??'',
  //   primaryContactFirstName: this.hotelMotel.get('primaryContactFirstName')?.value??'',
  //   primaryContactLastName: this.hotelMotel.get('primaryContactLastName')?.value??'',
  //   email:  this.hotelMotel.get('email')?.value??'',
  //   phone:  this.hotelMotel.get('phoneNumber')?.value??'',
  //   streetAddress: this.addressProperty.get('address1')?.value??'',
  //   aptUnitSuite:this.addressProperty.get('address2')?.value??'',
  //   city: this.addressProperty.get('city')?.value??'',
  //   stateId: Number.parseInt(this.addressProperty.get('state')?.value??'') ,
  //   zipCode: this.addressProperty.get('zipCode')?.value??'',
  //   webSiteUrl: this.addressProperty.get('websiteUrl')?.value??'',
  //   internationalAddressName:this.addressOwnerInternational.get('internationalAddressName')?.value??'',
  //   streetAddressPoBoxNumber: this.addressOwnerInternational.get('internationalPoBox')?.value??'',
  //   internationalCityStateProvince: this.addressOwnerInternational.get('internationalCityProvinceState')?.value??'',
  //   note: '',
  //   countryId:  Number.parseInt(this.addressOwnerInternational.get('internationalCountry')?.value??'') ,
  // };
  // this.enrollment.registerHotelMotel(hotelMotelEnrollment);
 }
  }
}
